import React from 'react'
import { Link } from 'react-router-dom'
import CarCard from './partials/CarCard'

const SavedCars = () => {

    const savedCarsList = JSON.parse(window.localStorage.getItem('bbUserFavorite') ?? '[]')
    const hasSavedCars = savedCarsList.length > 0;
    const numberOfSavedCars = savedCarsList.length

    return (
        <>
        <div className='container'>
            <div className='cars'>
                <h2 className="section-title">
                    {   hasSavedCars 
                            ?  <span>{numberOfSavedCars}</span>
                            : <>Mina</>
                    } sparade bilar</h2>

                { hasSavedCars ? 
                    <>
                        <div className='cars-wrapper'>
                            {
                                savedCarsList.map((savedCar, i) => {
                                    return <CarCard car={savedCar} key={`favorite_${i}`} className='col-3' />
                                })
                            }
                        </div>
                        <div className="py-4" style={{textAlign:'center'}}>
                            <Link className="text-block passion" to="/">Hitta fler bilar</Link>
                        </div>
                    </>
                    :

                    <div className="placeholder">
                        <h2>Just nu har du inga sparade bilar!</h2>
                        <p>Börja spara bilar du gillar lite extra genom att klicka på hjärtat eller Spara-knappen.<br />De bilarna sparas sedan här i din egna lista.</p>
                        <Link className="text-block passion" to="/">Hitta bilar</Link>
                    </div>

                }

            </div>
        </div>
        </>
        )
    }


export default SavedCars